import { FC, ReactNode } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MessageTranslator } from '@oneflowab/pomes';

import automationRulesReducer from '@app/reducers/entities/automation-rules';
import { AddAutomationRule } from '@app/components/modals/add-automation-rule/add-automation-rule';
import type { FormData } from '@app/components/modals/add-automation-rule/add-automation-rule';
import type { AppState } from '@app/reducers/app';

const QUERY_NAME = 'automation-rules';

interface Props {
  children: ReactNode;
  workspaceId: number;
  availableKeys?: {
    label: string;
    value: string;
  }[];
  message: MessageTranslator;
}

type State = AppState;

const AddAutomationRuleContainer: FC<Props> = ({ workspaceId, children, ...props }) => {
  const createState = useSelector((state: State) =>
    automationRulesReducer.getCreateSelector(state),
  );
  const dispatch = useDispatch();

  const createAutomationRule = ({ key, active, days }: FormData) => {
    dispatch(
      automationRulesReducer.createAutomationRule({
        data: {
          workspaceId,
          key: key.value,
          active: active === undefined ? 1 : Number(active),
          days,
        },
        pipe: {
          onSuccess: () => {
            dispatch(
              automationRulesReducer.queryAutomationRulesReload({
                name: QUERY_NAME,
              }),
            );
          },
        },
      }),
    );
  };

  const resetCreateState = () => {
    dispatch(automationRulesReducer.createAutomationRuleReset());
  };
  return (
    <AddAutomationRule
      createAutomationRule={createAutomationRule}
      createState={createState}
      resetCreateState={resetCreateState}
      {...props}
    >
      {children}
    </AddAutomationRule>
  );
};

export default AddAutomationRuleContainer;
